interface SmartBannerSerializerInput {
  description: string
  button_text: string
  link: string
  playmarket_button_text: string
  playmarket_link: string
  appgallery_button_text: string
  appgallery_link: string
}

export function SmartBannerSerializer(data?: SmartBannerSerializerInput) {
  return {
    description: data?.description ?? "",
    buttonText: data?.button_text ?? "",
    link: data?.link ?? "",
    playmarketButtonText: data?.playmarket_button_text ?? "",
    playmarketLink: data?.playmarket_link ?? "",
    appgalleryButtonText: data?.appgallery_button_text ?? "",
    appgalleryLink: data?.appgallery_link ?? "",
  }
}

export type SmartBannerSerializerOutput = ReturnType<
  typeof SmartBannerSerializer
>

export const SMART_BANNER_PRESET: SmartBannerSerializerOutput = {
  description: "",
  buttonText: "",
  link: "",
  playmarketButtonText: "",
  playmarketLink: "",
  appgalleryButtonText: "",
  appgalleryLink: "",
}
